module.exports = __webpack_public_path__ + "static/media/logo2.b1341b37.png";